var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.97 2.47a.75.75 0 0 1 .53-.22h3a.75.75 0 0 1 .75.75v.75h2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75v6a2.25 2.25 0 0 1-2.25 2.25h-4.5A2.25 2.25 0 0 1 4.5 13.5v-6a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75h2.25V3a.75.75 0 0 1 .22-.53ZM5.25 6h7.5v-.75h-7.5V6ZM6 7.5v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-6H6Zm4.5 6a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75Zm-3.75-.75a.75.75 0 0 0 1.5 0V9a.75.75 0 0 0-1.5 0v3.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgBin;